var readingProgress = document.getElementById('reading-progress');
if (readingProgress) {
    var target_1 = document.getElementById('content');
    var setProgress_1 = function () {
        if (!target_1) {
            return;
        }
        var totalHeight = target_1.clientHeight - target_1.offsetTop;
        var windowScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (windowScrollTop === 0) {
            return readingProgress.style.width = '0';
        }
        if (windowScrollTop > totalHeight) {
            return readingProgress.style.width = '100%';
        }
        return readingProgress.style.width = "".concat((windowScrollTop / totalHeight) * 100, "%");
    };
    setProgress_1();
    window.addEventListener('scroll', function () { return setProgress_1(); });
}
